module.exports = __webpack_public_path__ + "img/winter-olympics.295311af.jpg";